import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "pipeline-tile" }
const _hoisted_2 = {
  key: 0,
  class: "hint"
}
const _hoisted_3 = ["href", "target"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = ["href", "target"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { class: "duration" }
const _hoisted_11 = { class: "bottom" }
const _hoisted_12 = { class: "started" }
const _hoisted_13 = { class: "branch" }
const _hoisted_14 = { class: "user" }
const _hoisted_15 = {
  key: 1,
  class: "history"
}
const _hoisted_16 = ["href", "target"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(`inner ${_ctx.pipeline.details.status}`)
    }, [
      (_ctx.pipeline.hint)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_ctx.pipeline.hint_url)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: _ctx.pipeline.hint_url,
                  target: _ctx.pipeline.details.id,
                  class: "user"
                }, _toDisplayString(_ctx.pipeline.hint), 9, _hoisted_3))
              : _createCommentVNode("", true),
            (!_ctx.pipeline.hint_url)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.pipeline.hint), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("a", {
          href: _ctx.pipeline.details.web_url,
          target: _ctx.pipeline.details.id,
          class: "user"
        }, [
          (_ctx.show_namespace)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.pipeline.namespace) + "/" + _toDisplayString(_ctx.name), 1))
            : (_ctx.show_namespace_ommitted_group)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.pipeline.namespace.replace(/^[^/]+\/?/,"")) + "/" + _toDisplayString(_ctx.name), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.name), 1))
        ], 8, _hoisted_6)
      ]),
      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.pipelineDuration(_ctx.pipeline.details)), 1),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.formatAge(_ctx.pipeline.details.started_at)), 1),
        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.pipeline.details.ref), 1),
        _createElementVNode("div", _hoisted_14, _toDisplayString(`#${_ctx.pipeline.details.id}`), 1)
      ]),
      (_ctx._show_history)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("a", {
              href: _ctx.pipeline_history_link,
              target: _ctx.pipeline_history_link
            }, "history: " + _toDisplayString(_ctx.pipeline_history), 9, _hoisted_16)
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}